import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LifecycleManaging } from 'src/app/shared/abstract/lifecycle-managing';

@Component({
  selector: 'readonly-input',
  templateUrl: './readonly-input.component.html',
  styleUrls: ['./readonly-input.component.scss']
})
export class ReadonlyInputComponent extends LifecycleManaging implements OnInit {

  @Input() id: string;
  @Input() placeholder: string;
  @Input() value: string;
  @Input() translate = false;
  @Input() required = true;
  @Input() numberValue = false;
  @Input() valueChange: Observable<string>;
  @Input() matSuffix: string;

  formControl: UntypedFormControl;

  constructor(private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    if (!this.id) {
      console.error('Input id wasn\'t specified', this);
    }

    this.formControl = this.createFormControl();
    this.initValueChange();
  }

  private getControlValue() {
    if (this.translate) {
      if ((this.value !== null) && (this.value !== '')) {
        return this.translateService.instant(this.value);
      } else {
        console.warn('value for readonly-input is empty');
        return this.value;
      }
    } else {
      return this.value;
    }
  }

  private createFormControl(): UntypedFormControl {
    return new UntypedFormControl(this.getControlValue());
  }

  private initValueChange() {
    if (this.valueChange) {
      this.valueChange
        .pipe(takeUntil(this.destroySubject))
        .subscribe((value) => this.formControl.setValue(value));
    }
  }

}
